import * as z from "zod/v4";
import { onboardingV2AnalyticsProductIdSchema } from "./analytics-product-id";

export const archiveOnboardingV2Product = {
  name: "archiveOnboardingV2Product" as const,
  input: z.object({
    teamId: z.string().min(1),
    productId: onboardingV2AnalyticsProductIdSchema,
  }),
  output: z.object({ success: z.boolean() }),
};

export type ArchiveOnboardingV2ProductInput = z.infer<
  typeof archiveOnboardingV2Product.input
>;
export type ArchiveOnboardingV2ProductOutput = z.infer<
  typeof archiveOnboardingV2Product.output
>;
